module.exports = __webpack_public_path__ + "static/Tracer Perpetual Swaps-ea826cb7819c7655e078119ee7acf83e.pdf";